import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {levelSelector, tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import * as suggestionApi from "../../api/suggestionApi/suggestionApi";

import SuggestionForm from "./SuggestionForm";

import {EQSuggestion, initializeSuggestion} from "../../models/serverModels/report/EQSuggestion";

const UpdateSuggestion = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);
  const userLevel = useRecoilValue(levelSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: Suggestion, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQSuggestion>>({
    key: ["Suggestion", {token: tokenState, id: parseInt(id!)}],
    api: () => suggestionApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQSuggestion>,
    Params.Update<EQSuggestion>
  >({
    api: suggestionApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Suggestion`);
        queryClient.invalidateQueries("SuggestionList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQSuggestion>({defaultValues: initializeSuggestion()});

  const {reset} = methods;

  useEffect(() => {
    reset(Suggestion?.item);
  }, [Suggestion?.item, reset]);

  const onSubmit: SubmitHandler<EQSuggestion> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...Suggestion?.item, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="질의 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <SuggestionForm />
            <ConfirmButtonGroup
              link={userLevel === (1 || 2) ? "/Suggestion/All" : "/Suggestion"}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateSuggestion;
